// i18n.js - Plain JavaScript file without ERB
require("i18n-js");

import I18n from "i18n-js";

// Default to English, then try to get from meta tag
let locale = "en";
let docLocale;
try {
  const localeTag = document.querySelector("meta[name='locale']");
  if (localeTag) {
    locale = localeTag.getAttribute("content");
  }

  const docEditDiv = document.querySelector("div[data-documents-locale]");
  if (docEditDiv) {
    docLocale = docEditDiv.getAttribute("data-documents-locale");
  }
} catch (e) {
  console.error("Error getting locale:", e);
}

// Import all locales statically
const enLocales = require("../../locales/en.json");
const deLocales = require("../../locales/de.json");
const esLocales = require("../../locales/es.json");
const itLocales = require("../../locales/it.json");
const frLocales = require("../../locales/fr.json");
const nlLocales = require("../../locales/nl.json");

// Select the correct locale
let locales;
switch (locale) {
  case "de":
    locales = deLocales;
    break;
  case "es":
    locales = esLocales;
    break;
  case "it":
    locales = itLocales;
    break;
  case "fr":
    locales = frLocales;
    break;
  case "nl":
    locales = nlLocales;
    break;
  default:
    locales = enLocales;
}

if (docLocale && docLocale != "" && docLocale != locale) {
  switch (docLocale) {
    case "de":
      locales = Object.assign(locales, deLocales);
      break;
    case "es":
      locales = Object.assign(locales, esLocales);
      break;
    case "it":
      locales = Object.assign(locales, itLocales);
      break;
    case "fr":
      locales = Object.assign(locales, frLocales);
      break;
    case "nl":
      locales = Object.assign(locales, nlLocales);
  }
}

I18n.translations = locales;
I18n.defaultLocale = "en";
I18n.locale = locale;

window.I18n = I18n;
